export const AchievementActionTypes = {
  GET_ACHIEVEMENTS: 'GET_ACHIEVEMENTS'
}